import axios from "axios";
import React, { useState } from "react";
import urls from "../../urls";
import { showError, showSuccess } from "../../utils";

const CreateNewFacultyAccountForm = () => {
  const [facultyName, setfacultyName] = useState("");
  const [fullName, setFullName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(true);

  // Validate inputs
  const validateInputs = () => {
    const newErrors = {};
    if (!fullName.trim()) {
      newErrors.fullName = "الإسم الكامل مطلوب";
    }
    if (facultyName.trim() === "" || facultyName.trim().length < 6) {
      newErrors.facultyName =
        "اسم الكلية مطلوب يجب أن يتكوّن من 6 حروف على الاٌقل ";
    }
    if (!/\S+@\S+\.\S+/.test(adminEmail.trim())) {
      adminEmail.email = "البريد الإلكتروني غير صالح";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  const checkForValidfacultyName = (i) => {
    const newErrors = {};
    const facultyName = i.target.value;
    axios
      .post(urls.checkfacultyName, {
        facultyName,
      })
      .then((res) => {
        const { not_valid } = res.data;
        if (not_valid) {
          newErrors.facultyName = " اسم الكلّية موجود مسبقا يرجي تغييره ";
          setErrors(newErrors);
          setDisableSubmit(true);
        } else {
          setDisableSubmit(false);
          setErrors({});
        }
      })
      .catch((err) => console.log(err));

    console.log(facultyName);
  };

  const checkForValidAdminEmail = (i) => {
    const newErrors = {};
    const email = i.target.value;
    axios
      .post(urls.checkEmailExistance, {
        email,
      })
      .then((res) => {
        const { not_valid } = res.data;
        if (not_valid) {
          newErrors.AdminEmail = " البريد الالكتروني موجود مسبقا يرجي تغييره ";
          setErrors(newErrors);
          setDisableSubmit(true);
        } else {
          setDisableSubmit(false);
          setErrors({});
        }
      })
      .catch((err) => console.log(err));
  };
  // Handle form submission
  const handleSubmit = () => {
    if (validateInputs()) {
      axios
        .post(urls.createNewFacultyAccount, {
          facultyName,
          adminEmail,
        })
        .then(async (res) => {
          const faculty_id = res.data.results.insertId;
          await axios.post(urls.createNewUser, {
            fullName,
            email: adminEmail,
            job: "admin",
            password: "123456789",
            faculty_id,
          });

          showSuccess("تمّ إنشاء حساب  الكلّية بنجاح");
          setfacultyName(""); // Clear inputs
          setFullName(""); // Clear inputs
          setAdminEmail(""); // Clear inputs
          setErrors({}); // Clear errors
        })
        .catch((err) => {
          console.log(err);
          showError("حدث خطأ أثناء إنشاء الحساب ");
        });
    }
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (disableSubmit) return;
      handleSubmit();
    }
  };

  return (
    <div className="container mt-2 ">
      <div className=" form-control">
        {/* faculty name  */}
        <div className="mb-1">
          <label htmlFor="facultyName" className="form-label">
            اسم الكلّية
          </label>
          <input
            placeholder="اسم الكلّية"
            type="text"
            className={`form-control ${errors.facultyName ? "is-invalid" : ""}`}
            id="facultyName"
            value={facultyName}
            onChange={(e) => setfacultyName(e.target.value)}
            onKeyDown={handleKeyPress}
            onBlur={checkForValidfacultyName}
          />
          {errors.facultyName && (
            <div className="invalid-feedback" style={{ fontSize: "13px" }}>
              {errors.facultyName}
            </div>
          )}
        </div>
        {/* Full Name Field */}
        <div className="  mb-1">
          {" "}
          <label htmlFor="fullName"> إسم مدير النظام</label>
          <input
            type="text"
            className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
            id="fullName"
            placeholder="الإسم الكامل"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
          {errors.fullName && (
            <div className="invalid-feedback">{errors.fullName}</div>
          )}
        </div>

        {/* faculty admin email */}
        <div className="mb-3">
          <label htmlFor="adminEmail" className="form-label">
            البريد الالكتروني الخاص بمدير النظام في الكلّية
          </label>
          <input
            type="email"
            className={`form-control ${errors.adminEmail ? "is-invalid" : ""}`}
            id="adminEmail"
            value={adminEmail}
            onChange={(e) => setAdminEmail(e.target.value)}
            onKeyDown={handleKeyPress}
            onBlur={checkForValidAdminEmail}
          />
          {errors.adminEmail && (
            <div className="invalid-feedback" style={{ fontSize: "13px" }}>
              {errors.adminEmail}
            </div>
          )}
        </div>
        {/* إضافة Button */}
        <div className=" d-flex justify-content-end   ">
          <button
            className="btn btn-primary"
            style={{ width: "150px" }}
            onClick={handleSubmit}
            disabled={disableSubmit}
          >
            إضافة
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateNewFacultyAccountForm;
